import { lazy } from 'react';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import Module from '../component/ModulesParent/moduleParents';
import { PERMISSIONS } from './permissionsCode';
import ProtectedRoute from '../component/ProtectedRoute/protectedRoute';
import RevisePayrollIndexWrapper from 'Routes1/PayrollCTC_Route/revisePayrollIndexWrapper';
import AdminLeavesDataWrapper from 'Routes1/LeavesManagementRoute/adminLeaveWrapper';
import MyLeavesDataWrapper from 'Routes1/LeavesManagementRoute/myLeaveWrapper';
import InvoiceDataWrapper from 'Routes1/InvoiceParentRoute/invoiceWrapper';
import VendorsListWrapper from 'Routes1/VendorsParentRoute/vendorWrapper';
import ExpensesManagmentDataWrapper from 'Routes1/ExpensesParentRoute/expenseWrapper';
import ManagePaymentsWrapper from 'Routes1/ManagePaymentsRoute/paymentWrapper';
import MySalarySlip from 'Routes1/PayrollHistoryRoute/mySalarySlip';
import { usersDataSelector } from 'store1/user login data/user.login.data.slice.slector';
import { useSelector } from 'react-redux';

const RootRedirect = () => {
    const userData = useSelector(usersDataSelector);

    if (!userData?.empId) {
        return <Navigate to="/manage-masters" replace />;
    }

    return <Navigate to="/dashboard" replace />;
};

const MastersRoute = Loadable(lazy(() => import('../Modules/Masters/MastersParent')));
const CompanyMaster = Loadable(lazy(() => import('../Routes1/CompanyMasterViewRoute/companyMasterView')));
const CountryMaster = Loadable(lazy(() => import('../Routes1/CountryMasterRoute/countryDetailsList')));
const LookupMaster = Loadable(lazy(() => import('../Routes1/LookupDetailsRoute/lookUpDetailsList')));
const UserManagement = Loadable(lazy(() => import('../Routes1/UserManagement/userManagement')));
const UserAdd = Loadable(lazy(() => import('../Routes1/UserManagement/addUser')));
const ViewUser = Loadable(lazy(() => import('../Routes1/UserManagement/viewUser')));

// Manage Accounts - Direct Component Imports
const ClietsList = Loadable(lazy(() => import('../Routes1/ClientsParentRoute/ClientsList/clientsList')));
const NewClientRegister = Loadable(lazy(() => import('../Routes1/Register New Client/registerNewClient')));
const ClientDetails = Loadable(lazy(() => import('../Routes1/ClientsParentRoute/ClientDetails/clientDetails')));
const EditClient = Loadable(lazy(() => import('../Routes1/ClientsParentRoute/EditClient/editClient')));
const NewVendorRegister = Loadable(lazy(() => import('../Routes1/RegisterNewVendor/registerNewVendor')));
const VendorDetails = Loadable(lazy(() => import('../Routes1/VendorsParentRoute/vendorDetails/vendorDetails')));
const EditVendor = Loadable(lazy(() => import('../Routes1/VendorsParentRoute/EditVendor/editVendor')));
const InvoiceDetails = Loadable(lazy(() => import('../Routes1/InvoiceParentRoute/InvoiceDetails/invoiceDetails')));
const EditInvoice = Loadable(lazy(() => import('../Routes1/InvoiceParentRoute/EditInvoice/editInvoice')));
const CreateInvoice = Loadable(lazy(() => import('../Routes1/CreateNewInvoiceRoute/createInvoice')));
const PaymentDetails = Loadable(lazy(() => import('../Routes1/ManagePaymentsRoute/paymentDetails')));
const NewPaymentRegister = Loadable(lazy(() => import('../Routes1/Register New Payment/addNewPayment')));
const CustomerAccountSummary = Loadable(lazy(() => import('../Routes1/CustomerAccountSummaryRoute/customerAccountSummary')));
const CustomerAccount = Loadable(lazy(() => import('../Routes1/CustomerAccountDetailsRoute/customerAccountDetails')));
const ViewExpense = Loadable(lazy(() => import('../Routes1/ExpensesParentRoute/ViewExpense/viewExpense')));
const EditExpense = Loadable(lazy(() => import('../Routes1/ExpensesParentRoute/EditExpense/editExpense')));
const AddNewExpense = Loadable(lazy(() => import('../Routes1/CreateNewExpenseRoute/createNewExpense')));
const ExpensePieChartReport = Loadable(lazy(() => import('../Routes1/ExpenseReportRoute/pieChartReport')));
const ExpenseDetailsRoute = Loadable(lazy(() => import('../Routes1/ExpenseDetailsRoute/expenseDetailsRoute')));
const SystemSecurity = Loadable(lazy(() => import('../Routes1/SystemSecurity/systemSecurity')));
const ViewRole = Loadable(lazy(() => import('../Routes1/SystemSecurity/viewRole')));
const EmployessData = Loadable(lazy(() => import('../Routes1/EmployesParentRoute/Employess Data/employess.data')));
const NewEmployeeRegister = Loadable(lazy(() => import('../Routes1/AddNewEmployeeRoute/addNewEmployee')));
const EmployeeEdit = Loadable(lazy(() => import('../Routes1/EmployesParentRoute/Employee Edit/employeeEdit')));
const ViewEmployeDetail = Loadable(lazy(() => import('../Routes1/EmployesParentRoute/View Employee/viewEmploye')));
const EmployeeOfferLetter = Loadable(lazy(() => import('../Routes1/EmployesParentRoute/view Offer Letter/view_offer_letter')));
const ApplyLeave = Loadable(lazy(() => import('../Routes1/ApplyLeaveRoute/applyLeaveRoute')));
const LeaveDetails = Loadable(lazy(() => import('../Routes1/LeavesManagementRoute/LeavesDetails/LeaveDetails.style')));
const ViewLeave = Loadable(lazy(() => import('../Routes1/LeavesManagementRoute/ViewEmployeeLeave/viewEmployeeLeave')));
const EditLeave = Loadable(lazy(() => import('../Routes1/LeavesManagementRoute/EditLeave/editLeave')));

const PayrollCTCData = Loadable(lazy(() => import('../Routes1/PayrollCTC_Route/PayrollCTC_list/payroll.CTC.list')));
const PayrollHistoryList = Loadable(lazy(() => import('../Routes1/PayrollHistoryRoute/PayrollHistory_list/payrollHistoryList')));
const AdvanceData = Loadable(lazy(() => import('../Routes1/PayrollAdvanceRoute/AdvanceData/AdvanceData')));
const NewAdvanceRegister = Loadable(lazy(() => import('../Routes1/AddNewAdvancedRoute/AddNewAdvance')));
const SingleAdvanceDetailsPage = Loadable(lazy(() => import('../Routes1/SingleAdvanceDetailsPage/SingleAdvanceDetailsPage')));
const AddNewEmployeeCTC = Loadable(lazy(() => import('../Routes1/PayrollCTC_Route/AddNewEmployeeCTC/addNewEmployeeCtc')));
const GeneratePayrollDetailsData = Loadable(lazy(() => import('../Routes1/PayrollHistoryRoute/GeneratePayrolls/generatePayrolls')));
const ConfigurePayroll = Loadable(lazy(() => import('../Routes1/PayrollHistoryRoute/ConfigurePayroll/configPayroll')));
const AddPayrollCTC = Loadable(lazy(() => import('../Routes1/PayrollCTC_Route/ReviseEmployeePayrollRoute/PayrollCTC_Add/payrollCTC_add')));
const EditPayrollCTC = Loadable(
    lazy(() => import('../Routes1/PayrollCTC_Route/ReviseEmployeePayrollRoute/PayrollCTC_Edit/payrollCTC_edit'))
);
const ViewPayrollDetailsData = Loadable(
    lazy(() => import('../Routes1/PayrollHistoryRoute/ViewPayrollsRoute/ViewAllPayrollDetails/viewPayrolls'))
);
const EditEmployeePayrollDetail = Loadable(
    lazy(() => import('../Routes1/PayrollHistoryRoute/ViewPayrollsRoute/EditEmployeePayrollDetail/editEmployeePayrollDetail'))
);
const PrintEmployeePayrollDetail = Loadable(
    lazy(() => import('../Routes1/PayrollHistoryRoute/ViewPayrollsRoute/PrintEMployeePayrollDetail/printEmployeePayrollDetail'))
);

// ==============================|| MAIN ROUTING ||============================== //

const MapRoutes = [
    {
        path: '/',
        element: <RootRedirect />,
        screenKeyName: 'Dashboard'
    },
    {
        path: 'dashboard',
        element: <Module />,
        screenKeyName: 'Dashboard'
    },
    // ................
    // my leaves
    {
        path: 'dashboard/my-leaves',
        element: <MyLeavesDataWrapper />,
        screenKeyName: 'LeavesData'
    },
    {
        path: 'dashboard/my-leaves/apply-leave',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.LEAVE.APPLY || PERMISSIONS.HR.LEAVE.ADMIN_APPLY}>
                <ApplyLeave permission={PERMISSIONS.HR.LEAVE.APPLY} adminPermission={PERMISSIONS.HR.LEAVE.ADMIN_APPLY} />
            </ProtectedRoute>
        ),
        screenKeyName: 'ApplyLeave'
    },

    {
        path: 'dashboard/my-leaves/:leave_id/view-leave',
        element: <ViewLeave />,
        screenKeyName: 'ViewLeave'
    },
    {
        path: 'dashboard/my-leaves/:leave_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.LEAVE.APPLY || PERMISSIONS.HR.LEAVE.ADMIN_APPLY}>
                <EditLeave permission={PERMISSIONS.HR.LEAVE.APPLY} adminPermission={PERMISSIONS.HR.LEAVE.ADMIN_APPLY} />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditLeave'
    },
    // .......................
    // my expenses
    {
        path: 'dashboard/my-expenses',
        element: (
            <ProtectedRoute>
                <ExpensesManagmentDataWrapper permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL} />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditLeave'
    },
    {
        path: 'dashboard/my-expenses/:expense_id/edit',
        element: (
            <ProtectedRoute>
                <EditExpense permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL} />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditLeave'
    },

    {
        path: 'dashboard/my-expenses/:expense_id/view-expense',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <ViewExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'ViewExpense'
    },

    {
        path: 'dashboard/my-expenses/add-expense',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.SUBMIT}>
                <AddNewExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'AddNewExpense'
    },

    {
        path: 'dashboard/my-salary-slip',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.EMPLOYEE.SALARY}>
                <MySalarySlip />
            </ProtectedRoute>
        ),
        screenKeyName: 'AddNewExpense'
    },

    // Manage Masters
    {
        path: 'manage-masters/*',
        element: (
            <ProtectedRoute>
                <MastersRoute permission={PERMISSIONS.SYSTEM.MASTER.MANAGE_MASTER} />
            </ProtectedRoute>
        ),
        screenKeyName: 'MastersRoute'
    },

    {
        path: 'manage-masters/company-master*',
        element: (
            <ProtectedRoute permission={PERMISSIONS.SYSTEM.MASTER.COMPANY_MASTER}>
                <CompanyMaster />
            </ProtectedRoute>
        ),
        screenKeyName: 'CompanyMaster'
    },

    {
        path: 'manage-masters/lookup-master*',
        element: (
            <ProtectedRoute>
                <LookupMaster />
            </ProtectedRoute>
        ),
        screenKeyName: 'LookupMaster'
    },

    {
        path: 'manage-masters/country-master*',
        element: (
            <ProtectedRoute permission={PERMISSIONS.SYSTEM.MASTER.COUNTRY_MASTER}>
                <CountryMaster />
            </ProtectedRoute>
        ),
        screenKeyName: 'CountryMaster'
    },

    {
        path: 'manage-masters/user-management*',
        element: (
            <ProtectedRoute permission={PERMISSIONS.SYSTEM.USER.VIEW}>
                <UserManagement />
            </ProtectedRoute>
        ),
        screenKeyName: 'UserManagement'
    },

    {
        path: 'manage-masters/user-management/add-user/*',
        element: (
            <ProtectedRoute permission={PERMISSIONS.SYSTEM.USER.CREATE}>
                <UserAdd />
            </ProtectedRoute>
        ),
        screenKeyName: 'UserAdd'
    },

    {
        path: 'manage-masters/system-security/:id/view',
        element: (
            <ProtectedRoute permission={PERMISSIONS.SYSTEM.ROLE.VIEW}>
                <ViewRole />
            </ProtectedRoute>
        ),
        screenKeyName: 'ViewRole'
    },
    {
        path: 'manage-masters/system-security*',
        element: SystemSecurity,
        // element: (
        //     <ProtectedRoute permission={PERMISSIONS.SYSTEM.ROLE.VIEW}>
        //         <SystemSecurity />
        //     </ProtectedRoute>
        // ),
        screenKeyName: 'SystemSecurity'
    },

    {
        path: 'manage-masters/user-management/:id/view',
        element: ViewUser,
        screenKeyName: 'ViewUser'
    },
    // ..................................................................

    // Employee Management - Index Route
    {
        path: 'employee-management',
        element: <Module />,
        screenKeyName: 'EmployeeManagement'
    },

    // Employee Management - Employees List Routes - FIXED
    {
        path: 'employee-management/employees-list',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.EMPLOYEE.LIST}>
                <EmployessData />
            </ProtectedRoute>
        ),
        screenKeyName: 'EmployeesDataRoute'
    },
    {
        path: 'employee-management/employees-list/add-employee',
        element: <NewEmployeeRegister />,
        screenKeyName: 'NewEmployeeRegister',
        permission: PERMISSIONS.HR.EMPLOYEE.CREATE
    },
    {
        path: 'employee-management/employees-list/:id/edit',
        element: <EmployeeEdit />,
        screenKeyName: 'EmployeeEdit',
        permission: PERMISSIONS.HR.EMPLOYEE.CREATE
    },
    {
        path: 'employee-management/employees-list/:id/view-employee',
        element: <ViewEmployeDetail />,
        screenKeyName: 'ViewEmployeDetail',
        permission: PERMISSIONS.HR.EMPLOYEE.VIEW
    },
    {
        path: 'employee-management/employees-list/:id/view-employee/view-offerLetter',
        element: <EmployeeOfferLetter />,
        screenKeyName: 'EmployeeOfferLetter'
    },

    // Employee Management - Leave Management Routes
    {
        path: 'employee-management/leave-management',
        element: <Module />,
        screenKeyName: 'LeaveManagement'
    },
    {
        path: 'employee-management/leave-management/employee-leaves',
        element: <AdminLeavesDataWrapper />,
        screenKeyName: 'LeavesData'
    },

    {
        path: 'employee-management/leave-management/employee-leaves/apply-leave',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.LEAVE.APPLY || PERMISSIONS.HR.LEAVE.ADMIN_APPLY}>
                <ApplyLeave permission={PERMISSIONS.HR.LEAVE.APPLY} adminPermission={PERMISSIONS.HR.LEAVE.ADMIN_APPLY} />
            </ProtectedRoute>
        ),
        screenKeyName: 'ApplyLeave'
    },
    {
        path: 'employee-management/leave-management/leave-summary',
        element: (
            <ProtectedRoute permission={PERMISSIONS.REPORTS.LEAVE_SUMMARY}>
                <LeaveDetails />
            </ProtectedRoute>
        ),
        screenKeyName: 'LeaveDetails'
    },
    {
        path: 'employee-management/leave-management/employee-leaves/view-all-leaves/:leave_id/view-leave',
        element: <ViewLeave />,
        screenKeyName: 'ViewLeave'
    },
    {
        path: 'employee-management/leave-management/employee-leaves/:leave_id/view-leave',
        element: <ViewLeave />,
        screenKeyName: 'ViewLeave'
    },
    {
        path: 'employee-management/leave-management/employee-leaves/:leave_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.HR.LEAVE.APPLY || PERMISSIONS.HR.LEAVE.ADMIN_APPLY}>
                <EditLeave permission={PERMISSIONS.HR.LEAVE.APPLY} adminPermission={PERMISSIONS.HR.LEAVE.ADMIN_APPLY} />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditLeave'
    },

    // Employee Management - Payroll Management Routes - FIXED
    {
        path: 'employee-management/payroll-management',
        element: <Module />,
        screenKeyName: 'PayrollManagement'
    },
    {
        path: 'employee-management/payroll-management/employee-salaries',
        element: <PayrollCTCData />,
        screenKeyName: 'PayrollCTCData'
    },
    {
        path: 'employee-management/payroll-management/run-payroll',
        element: <PayrollHistoryList />,
        screenKeyName: 'PayrollHistoryList'
    },
    {
        path: 'employee-management/payroll-management/employee-advance',
        element: <AdvanceData />,
        screenKeyName: 'AdvanceData'
    },
    {
        path: 'employee-management/payroll-management/employee-advance/add',
        element: <NewAdvanceRegister />,
        screenKeyName: 'NewAdvanceRegister'
    },
    {
        path: 'employee-management/payroll-management/employee-advance/:id/edit',
        element: <NewAdvanceRegister />,
        screenKeyName: 'NewAdvanceRegister'
    },
    {
        path: 'employee-management/payroll-management/employee-advance/:id/view',
        element: <SingleAdvanceDetailsPage />,
        screenKeyName: 'SingleAdvanceDetailsPage'
    },
    {
        path: 'employee-management/payroll-management/employee-salaries/:emp_id/revise',
        element: <RevisePayrollIndexWrapper />,
        screenKeyName: 'RevisePayrollIndex'
    },
    {
        path: 'employee-management/payroll-management/employee-salaries/:emp_id/revise/revise-salary',
        element: <AddPayrollCTC />,
        screenKeyName: 'AddPayrollCTC'
    },
    {
        path: 'employee-management/payroll-management/employee-salaries/:emp_id/revise/:id/edit-draft',
        element: <EditPayrollCTC />,
        screenKeyName: 'EditPayrollCTC'
    },
    {
        path: 'employee-management/payroll-management/employee-salaries/:emp_id/add-CTC',
        element: <AddNewEmployeeCTC />,
        screenKeyName: 'AddNewEmployeeCTC'
    },
    {
        path: 'employee-management/payroll-management/run-payroll/:master_id/monthly-salary',
        element: <ViewPayrollDetailsData />,
        screenKeyName: 'ViewPayrollDetailsData'
    },
    {
        path: 'employee-management/payroll-management/run-payroll/:master_id/monthly-salary/:payroll_detail_id/edit-employee-payroll',
        element: <EditEmployeePayrollDetail />,
        screenKeyName: 'EditEmployeePayrollDetail'
    },
    {
        path: 'employee-management/payroll-management/run-payroll/:master_id/monthly-salary/:payroll_detail_id/print-salary-slip',
        element: <PrintEmployeePayrollDetail />,
        screenKeyName: 'PrintEmployeePayrollDetail'
    },
    {
        path: 'employee-management/payroll-management/run-payroll/generate-payroll',
        element: <GeneratePayrollDetailsData />,
        screenKeyName: 'GeneratePayrollDetailsData'
    },

    {
        path: 'employee-management/payroll-management/run-payroll/configure-payroll',
        element: <ConfigurePayroll />,
        screenKeyName: 'ConfigurePayroll'
    },

    // ..........................................................

    // Manage Accounts - Index Route
    {
        path: 'manage-accounts',
        element: Module,
        screenKeyName: 'ManageAccounts'
    },

    // Manage Accounts - Client Management Routes
    {
        path: 'manage-accounts',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CLIENT_LIST}>
                <Module />
            </ProtectedRoute>
        ),
        screenKeyName: 'ClientManagement'
    },
    {
        path: 'manage-accounts/client-list',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CLIENT_LIST}>
                <ClietsList />
            </ProtectedRoute>
        ),
        screenKeyName: 'ClientsList'
    },
    {
        path: 'manage-accounts/client-list/add-client',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CLIENT_ADD}>
                <NewClientRegister />
            </ProtectedRoute>
        ),
        screenKeyName: 'NewClientRegister'
    },
    {
        path: 'manage-accounts/client-list/:client_id/client-details',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CLIENT_LIST}>
                <ClientDetails />
            </ProtectedRoute>
        ),
        screenKeyName: 'ClientDetails'
    },
    {
        path: 'manage-accounts/client-list/:client_id/edit',
        element: EditClient,
        screenKeyName: 'EditClient'
    },

    // Manage Accounts - Vendor Management Routes
    // {
    //     path: 'manage-accounts',
    //     element: (
    //         <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VENDOR_ADD}>
    //             <Module />
    //         </ProtectedRoute>
    //     ),
    //     screenKeyName: 'VendorManagement'
    // },
    {
        path: 'manage-accounts/vendors-list',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VENDOR_ADD}>
                <VendorsListWrapper />
            </ProtectedRoute>
        ),
        screenKeyName: 'VendorsList'
    },
    {
        path: 'manage-accounts/vendors-list/add-vendor',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VENDOR_ADD}>
                <NewVendorRegister />
            </ProtectedRoute>
        ),
        screenKeyName: 'NewVendorRegister'
    },
    {
        path: 'manage-accounts/vendors-list/:vendor_id/vendor-details',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VENDOR_DETAILS}>
                <VendorDetails />
            </ProtectedRoute>
        ),
        screenKeyName: 'VendorDetails'
    },
    {
        path: 'manage-accounts/vendors-list/:vendor_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VENDOR_EDIT}>
                <EditVendor />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditVendor'
    },

    // Manage Accounts - Invoice Management Routes
    {
        path: 'manage-accounts/invoice-management',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VIEW}>
                <Module />
            </ProtectedRoute>
        ),
        screenKeyName: 'InvoiceManagement'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VIEW}>
                <InvoiceDataWrapper />
            </ProtectedRoute>
        ),
        screenKeyName: 'InvoiceData'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list/:invoice_id/view-invoice',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VIEW}>
                <InvoiceDetails />
            </ProtectedRoute>
        ),
        screenKeyName: 'InvoiceDetails'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list/:invoice_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.VIEW}>
                <EditInvoice />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditInvoice'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list/add-invoice',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CREATE}>
                <CreateInvoice />
            </ProtectedRoute>
        ),
        screenKeyName: 'CreateInvoice'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list/add-invoice/:invoice_id',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CREATE}>
                <InvoiceDetails />
            </ProtectedRoute>
        ),
        screenKeyName: 'CreateInvoiceDetails'
    },
    {
        path: 'manage-accounts/invoice-management/invoice-list/add-invoice/:invoice_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.FINANCE.INVOICE.CREATE}>
                <EditInvoice />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditInvoiceFromCreate'
    },

    // Manage Accounts - Payment Management Routes
    {
        path: 'manage-accounts/payment-management',
        element: Module,
        screenKeyName: 'PaymentManagement'
    },
    {
        path: 'manage-accounts/receipt',
        element: ManagePaymentsWrapper,
        screenKeyName: 'ManagePayments'
    },
    {
        path: 'manage-accounts/receipt/:payment_id/receipt-details',
        element: PaymentDetails,
        screenKeyName: 'PaymentDetails'
    },
    {
        path: 'manage-accounts/receipt/:payment_id/add-payment',
        element: NewPaymentRegister,
        screenKeyName: 'NewPaymentRegister'
    },

    // Manage Accounts - Reports Routes
    {
        path: 'manage-accounts/reports',
        element: Module,
        screenKeyName: 'Reports'
    },
    {
        path: 'manage-accounts/reports/client-report-summary',
        element: CustomerAccountSummary,
        screenKeyName: 'CustomerAccountSummary'
    },
    {
        path: 'manage-accounts/reports/client-account-detail',
        element: CustomerAccount,
        screenKeyName: 'CustomerAccount'
    },

    // Manage Accounts - Expense Management Routes
    {
        path: 'manage-accounts/expense-management',
        element: Module,
        screenKeyName: 'ExpenseManagement'
    },
    {
        path: 'manage-accounts/expense-management/expenses-list',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <ExpensesManagmentDataWrapper />
            </ProtectedRoute>
        ),
        screenKeyName: 'ExpensesList'
    },
    {
        path: 'manage-accounts/expense-management/expenses-list/:expense_id/view-expense',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <ViewExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'ViewExpense'
    },
    {
        path: 'manage-accounts/expense-management/expenses-list/:expense_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <EditExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditExpense'
    },
    {
        path: 'manage-accounts/expense-management/expenses-list/add-expense',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.SUBMIT}>
                <AddNewExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'AddNewExpense'
    },
    {
        path: 'manage-accounts/expense-management/pending-expenses-management',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <ExpensesManagmentDataWrapper />
            </ProtectedRoute>
        ),
        screenKeyName: 'PendingExpensesManagement'
    },
    {
        path: 'manage-accounts/expense-management/pending-expenses-management/:expense_id',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <ViewExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'ViewPendingExpense'
    },
    {
        path: 'manage-accounts/expense-management/pending-expenses-management/:expense_id/edit',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL}>
                <EditExpense />
            </ProtectedRoute>
        ),
        screenKeyName: 'EditPendingExpense'
    },
    {
        path: 'manage-accounts/expense-management/expense-report',
        element: (
            <ProtectedRoute permission={PERMISSIONS.EXPENSES.EXPENSE.COMPANY_EXPENSE_SUMMARY}>
                <ExpensePieChartReport />
            </ProtectedRoute>
        ),
        screenKeyName: 'ExpensePieChartReport'
    },
    {
        path: 'manage-accounts/expense-management/expense-details',
        element: ExpenseDetailsRoute,
        screenKeyName: 'ExpenseDetailsRoute'
    }
];

export default MapRoutes;
